<!--
  アイデア投稿マップの表示
-->
<template>
  <v-main class="pa-0 profs">
    <l-map
      ref="map"
      @click="addMarker"
      style="height: 100%; width: 100%; z-index: 5 !important"
      :zoom="15"
      :center="[locate.lat, locate.lng]"
    >
      <l-tile-layer
        :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'"
        :attribution="attribution"
      ></l-tile-layer>
      <Vue2LeafletMarkerCluster>
        <l-marker
          v-for="ide in ideaque"
          :key="ide.id"
          :lat-lng="[ide.latlngInputLat, ide.latlngInputLng]"
        >
          <l-popup>
            <div class="primary--text">
              {{ ide.content }} ({{ ide.timeday }})
            </div>
          </l-popup>
        </l-marker>
      </Vue2LeafletMarkerCluster>
    </l-map>
    <!--デバッグデータ確認用-->
    <!--
    <v-list id="activitylog" class="pa0">
      <v-list-item v-for="activity in ideaque" :key="activity.id">
        <v-card class="mx-auto" width="300px" min-height="50">
          <v-container>
            <v-row>
              <v-col cols="2">
                <v-img
                  src="../../assets/svg/5040.svg"
                  width="40px"
                  v-if="activity.logclass == 'ideapost'"
                ></v-img>
              </v-col>
              <v-col
                >{{ activity.latlngInputLat }},{{ activity.latlngInputLng
                }}<BR />{{ activity.content }}</v-col
              >
            </v-row>
          </v-container>
        </v-card>
      </v-list-item>
    </v-list>
    -->
  </v-main>
</template>
  <script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "leaflet/dist/leaflet.css";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import L from "leaflet";
//import VoteProject from '../components/dashboard/voteProject.vue';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  data() {
    return {
      db: firebase.firestore(),
      uid: firebase.auth().currentUser.uid,
      ideaque: [],
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      data_location_lat: Number(
        process.env.VUE_APP_LOCATION_LAT || 35.6813320349034
      ),
      data_location_lng: Number(
        process.env.VUE_APP_LOCATION_LNG || 139.76716771167693
      ),
      latlngInput: {},
      locate: { lat: 0, lng: 0 },
      markers: { lat: 0, lng: 0 },
    };
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    Vue2LeafletMarkerCluster,
  },
  props: ["profuid"],
  created() {
    this.getlog();
  },
  mounted() {
    this.markers = { lat: this.data_location_lat, lng: this.data_location_lng };
    this.locate = { lat: this.data_location_lat, lng: this.data_location_lng };
  },
  watch: {
    profuid: function (profuid) {
      this.getlog();
    },
  },
  methods: {
    addMarker(event) {
      console.log(event.latlng);
      //this.markers.push(event.latlng);
    },
    getlog(logclass = null) {
      if (logclass == null) {
        let collection = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.profuid)
          .collection("activity")
          .orderBy("date", "desc");
        collection
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              if (doc.data().logclass == "ideapost") {
                this.getidea(doc.data().lidid, doc.data().dataid);
              }
            });
          })
          .catch((error) => {
            console.log(
              "アクティビティログの取得でエラーが発生しました",
              error
            );
          });
      }
    },
    getidea(lidid, docid) {
      let docRef = this.db
        .collection("0")
        .doc(lidid)
        .collection("idea")
        .doc(docid);
      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            if (
              doc.data().latlngInputLat != 0 &&
              doc.data().latlngInputLng != 0
            ) {
              // 位置情報が無いものを除外
              this.ideaque.push(doc.data());
            }
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 959px) {
  .profs {
    height: 100vh;
    bottom: 100px;
    left: 0px;
    position: relative;
  }
}
@media screen and (min-width: 960px) {
  .profs {
    height: 100%;
  }
}
.pagetitle {
  font-size: large;
  color: #707070;
}
* {
  font-family: mplus-2c-medium;
}
</style>